import { render, staticRenderFns } from "./Contribution_Mobile.vue?vue&type=template&id=6388639b&scoped=true"
import script from "./Contribution_Mobile.vue?vue&type=script&lang=js"
export * from "./Contribution_Mobile.vue?vue&type=script&lang=js"
import style0 from "./Contribution_Mobile.vue?vue&type=style&index=0&id=6388639b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388639b",
  null
  
)

export default component.exports